// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3zQ-A","resendInfoText":"OnGoingPaymentBox_resendInfoText__14lZQ"};